import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;

  @media (max-width: 324px){
    flex-direction: column;
    justify-content: center;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  color: #000FFF;
  font-weight: bold;
  padding-right: 5px;
  padding-bottom: 10px;
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 14px;
  font-weight: 500;
`;

export const Left = styled.div`
  margin-left: 10px;
  display:flex;
  flex-direction: row;
  gap: 5px;
`

export const Details = styled.div`
  padding: 0px 10px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color ? "#c9c9c9" : "#000FFF" };
  color: #FFF;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
`

export const ToolTipButton = styled.a`
  cursor: pointer;
  padding: 20px;
`;

export const ToolTipText = styled.span``;